module.exports = __webpack_public_path__ + "static/media/vip-trophy-2.d0c1e792.png";